/* istanbul ignore file */

import { useCallback, useContext, useEffect } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'
import { WayflyerUiSdk } from '@wf-financing/ui-sdk'

import AppContext from '@/common/context/app.context'
import commonServices from '@/common/services/services'

import { getCompanyDataPayload } from './helpers'

const useWayFlyer = ({ language }) => {
  const { info } = useContext(AppContext)
  const { data, loading } = useFetch(commonServices.getWayFlyerToken, { doInitialRequest: info.userInfo.is_owner })
  const { fetchData: setWayFlyerProcessAsInitialized } = useFetch(commonServices.setWayFlyerProcessAsInitialized, {
    doInitialRequest: false,
  })

  const mountCta = useCallback(
    async (token, isInitialized) => {
      if (token) {
        const sdk = await WayflyerUiSdk.loadSdk(token, {
          isSandbox: import.meta.env.VITE_WAYFLYER_ENVIRONMENT === 'sandbox',
          language: language || 'en',
        })
        sdk.mountCta('wayflyer-cta-container', () => {
          if (isInitialized === false) {
            setWayFlyerProcessAsInitialized()
          }

          return getCompanyDataPayload(info)
        })
      }
    },
    [info, language, setWayFlyerProcessAsInitialized]
  )

  useEffect(() => {
    if (data && data.token) {
      mountCta(data.token, data?.is_initialized)
    }
  }, [data, mountCta])

  return { data, loading }
}

export default useWayFlyer
